export default {
  phoneOnly: '(max-width: 559px)',
  tablet: '(min-width: 600px)',
  smallDesktop: '(min-width: 900px)',
  desktop: '(min-width: 1200px)',
  largeDesktop: '(min-width: 1800px)'
};
